import React from "react";
import { Link } from "react-router-dom";

const LegalPage = ({ title, sections, lastUpdated }) => (
  <main
    className="min-h-screen bg-[#FAF8F3] text-[#1A1A1A] font-sans antialiased"
    data-testid={`legal-page-${title.toLowerCase()}`}
  >
    <header className="border-b border-[#E5E0D2]">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-6 md:py-8 flex items-center justify-between">
        <Link
          to="/"
          className="text-[11px] tracking-[0.24em] uppercase text-[#6B6359] hover:text-[#1F7A40] font-sans font-semibold transition-colors duration-300"
          data-testid="legal-back-link"
        >
          ← MatiMitra
        </Link>
        <span className="text-[11px] tracking-[0.24em] uppercase text-[#6B6359] font-sans font-semibold">
          {title}
        </span>
      </div>
    </header>

    <article className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
      <h1 className="font-serif text-4xl md:text-5xl leading-[1.1] tracking-[-0.01em] font-light text-[#1A1A1A]">
        {title}
      </h1>
      {lastUpdated && (
        <p className="mt-4 text-xs md:text-sm tracking-wide text-[#6B6359] font-sans">
          Last updated: {lastUpdated}
        </p>
      )}

      <div className="mt-12 md:mt-16 space-y-10">
        {sections.map((s, i) => (
          <section key={i}>
            <h2 className="font-serif text-2xl md:text-[1.75rem] leading-tight font-light text-[#1A1A1A]">
              {s.heading}
            </h2>
            {s.body.map((p, j) => (
              <p
                key={j}
                className="mt-4 text-[#3D3A33] text-base leading-[1.75] font-sans font-light"
              >
                {p}
              </p>
            ))}
          </section>
        ))}
      </div>

      <div className="mt-20 pt-10 border-t border-[#E5E0D2] flex items-center justify-between text-xs md:text-[13px] text-[#6B6359] font-sans">
        <Link to="/" className="hover:text-[#1F7A40] transition-colors duration-300">
          ← Back to home
        </Link>
        <span>
          Questions? Email{" "}
          <a
            href="mailto:support@matimitra.earth"
            className="text-[#1F7A40] hover:underline"
          >
            support@matimitra.earth
          </a>
        </span>
      </div>
    </article>
  </main>
);

export default LegalPage;
